import { render, staticRenderFns } from "./InfoForAbitur.vue?vue&type=template&id=2cb1a1b6&scoped=true&"
import script from "./InfoForAbitur.vue?vue&type=script&lang=js&"
export * from "./InfoForAbitur.vue?vue&type=script&lang=js&"
import style0 from "./InfoForAbitur.vue?vue&type=style&index=0&id=2cb1a1b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb1a1b6",
  null
  
)

export default component.exports